import React, {useEffect, useState} from "react";
import "./style.scss";
import {useTranslation} from "react-i18next";

const TokenBlockCard = ({
  tokenDetail,
  expandSelectedTurnero,
  deleteSelectedTurnero,
}) => {
  const {t} = useTranslation();
  const [token, setToken] = useState({});
  useEffect(() => {
    setToken(tokenDetail);
  }, [tokenDetail.tokenDetail, tokenDetail.peopleBeforeThisToken]);
  return (
    <div className="turneroStatus-list-eachitem" key={token.bookingId}>
      <div
        className="turneroStatus-list-item"
        onClick={() => {
          expandSelectedTurnero(token.bookingId);
        }}
      >
        <div className="turneroStatus-item-left">
          <div className="turneroStatus-tokenText">
            {t("turn")}
            <div className="turneroStatus-tokenNumber">{token.tokenNumber}</div>
          </div>
        </div>
        <div className="turneroStatus-item-right">
          <label className="turneroStatus-item-right-text">
            {token.serviceType}
          </label>
          <label className="turneroStatus-item-right-text">
            {t("peopleBeforeInQueue.label")}: {token.peopleBeforeThisToken}
          </label>
          <label className="turneroStatus-item-right-text turneroStatus-item-right-text-bottom">
            {token.storeName}
          </label>
        </div>
      </div>
      <div className="turneroStatus-footer-div">
        <div
          className="trash-img"
          onClick={() => {
            deleteSelectedTurnero(token.bookingId);
          }}
        ></div>
      </div>
    </div>
  );
};

export default TokenBlockCard;
